import { render, staticRenderFns } from "./SignatureV1.vue?vue&type=template&id=c556215e&scoped=true&"
import script from "./SignatureV1.vue?vue&type=script&lang=js&"
export * from "./SignatureV1.vue?vue&type=script&lang=js&"
import style0 from "./SignatureV1.vue?vue&type=style&index=0&id=c556215e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c556215e",
  null
  
)

export default component.exports